import { Icon } from 'antd';
import React from 'react';

const optionsDefault = {
  okText: 'Готово',
  icon: <Icon type="check-circle" theme="filled" />,
  closable: false,
  maskClosable: true,
  centered: true,
  className: 'employee-success-form',
  onOk() {},
  onCancel() {},
};

export const successEditCustomer = username => ({
  ...optionsDefault,
  title: 'Изменения успешно сохранены!',
  content: `Изменения успешно внесены в профиль заказчика «${username}»`,
});

export const successAddCustomer = username => ({
  ...optionsDefault,
  title: 'Заказчик успешно добавлен!',
  content: `Заказчик ${username} добавлен в систему!`,
});
